import PropTypes from 'prop-types';

import { TrustpilotWidget } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { TEMPLATE_IDS } from '@spotahome/ui-library/src/tenant/components/TrustpilotWidget/TrustpilotWidget';

import Section from '../LandingSection';

import './LandingTestimonialsSection.scss';

const LandingTestimonialsSection = ({ renderTitle = null }) => {
  return (
    <Section className="landing-testimonials-section">
      {renderTitle ? (
        renderTitle()
      ) : (
        <h2 className="landing-testimonials-section__title">
          {trans('how_it_works.testimonials.title')}
        </h2>
      )}
      <TrustpilotWidget
        className="landing-testimonials-section__widget"
        template={TEMPLATE_IDS.SLIDER}
        width="100%"
        height={160}
      />
    </Section>
  );
};

LandingTestimonialsSection.propTypes = {
  renderTitle: PropTypes.func
};

export default LandingTestimonialsSection;
